// src/pages/Home.js 
import React from 'react'

const Home = () => {
  return (
    <div className='content pageStyle'>
        <h1 className='pageTitle'>NASA Picture of the Day</h1>
        <div className='divider'></div>
        <p className='pageContent'>Coxswain mutiny crimp blow the man down Cat o'nine tails Letter of Marque quarterdeck. Barbary Coast broadside aft yard carouser strike colors chase. Ye bowsprit to go on account grog blossom hulk gun rum.</p>
    </div>
  )
}

export default Home 